<template>
  <el-card :shadow="shadow" :class="{ small }">
    <el-row slot="header">
      <el-col :span="14">
        <EditName
          size="mini"
          :name="role.project.name"
          :disabled="!(permission('owner', role.access) || permission('admin', role.access))"
          @change="updateName"
        />
      </el-col>

      <el-col :span="10">
        <el-button
          v-if="!active && !small"
          class="switch"
          type="info"
          size="mini"
          @click="$emit('click', role.id)"
        >
          {{ label }}
        </el-button>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="small ? 24 : 24">
        <div class="account">
          <h3>
            <span v-if="permission('owner', role.access)">Owner</span>
            <span v-else-if="permission('admin', role.access)">Administrator</span>
            <span v-else-if="permission('manager', role.access)">Manager</span>
            <span v-else-if="permission('developer', role.access)">Developer</span>
            <span v-else-if="permission('accounting', role.access)">Accounting</span>

            <el-tag size="mini" type="info">{{ accountName(client) }}</el-tag>
          </h3>

          <ProductDescription v-if="showProduct" :client="client" :show-list="false" />

          <TeamQuota v-if="client.team" :client="client" label="Team Quota" />
        </div>
      </el-col>

      <el-col :span="small ? 24 : 12">
      </el-col>
    </el-row>

    <el-button
      v-if="!active && small"
      class="switch"
      type="info"
      size="small"
      @click="$emit('click', role.id)"
    >
      {{ label }}
    </el-button>
  </el-card>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import EditName from '../EditName'
import ProductDescription from './ProductDescription'
import TeamQuota from '../Team/Quota'

export default {
  props: {
    role: {
      type: Object,
      default: () => ({})
    },
    small: {
      type: Boolean,
      default: false
    },
    showProduct: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      default: 'Switch to the project'
    }
  },
  components: {
    EditName,
    ProductDescription,
    TeamQuota
  },
  computed: {
    active () {
      return this.roleId === this.role.id
    },
    shadow () {
      return this.active ? 'always' : 'none'
    },
    client () {
      return this.role.project.client
    },
    ...mapState(['roleId']),
    ...mapGetters(['permission'])
  },
  methods: {
    updateName (name) {
      this.$store.dispatch('updateProject', {
        ...this.role.project,
        name
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../theme";

  .switch {
    width: 100%;
  }
  .el-row + .switch {
    margin-top: 10px;
  }

  .account {
    background-color: $--background-color-base;
    padding: 10px;

    h3, h4 {
      margin-top: 0;
      color: $--color-text-gray;
      font-size: 12px;
      line-height: 20px;

      .el-tag {
        float: right;
      }
    }
  }
</style>
